
import React, { forwardRef, useEffect, useState, useMemo, useCallback } from 'react';
import ToolsIntegrationsAPI from 'restAPI/ToolsIntegrationAPI';
import { FieldTypes } from 'utils/formUtils';
import message from "components/CustomMessage";
import GenericMappingForm from '../GenericMappingForm';
import { Form } from 'antd';
import { isEmpty, map } from 'lodash';

const SecurityScorecardMappingForm = forwardRef(function SecurityScorecardMappingForm(props, ref) {
  const [projects, setProjects] = useState(()=>{
    if(props.record){
      const {companyName, companyDomain, portfolioId, portfolioName} = props.record
      
      return parseGroupSelectOption([{id: companyDomain, name: companyName, otherProperties: { portfolioId, portfolioName }}])
    }
    return {}
  });
  const [form] = Form.useForm();
  const [initialValues] = useState(() => {
    if (props.record) {
      return undefined;
    }
    return [
      {
        product: props.defaultProduct,
        subProduct: props.defaultSubProduct,
        subProductId: props.defaultSubProductId,
        environment: props.defaultEnvironment,
      },
    ];
  });

  useEffect(() => {
    try {
      const { promise, cancel } = ToolsIntegrationsAPI.getGenericProjectByToolName(props.toolName, { login_id: props.loginConfigId });
      promise.then((response) => {
        const { projects } = response;
        setProjects(parseGroupSelectOption(projects));
      });

      return cancel;
    } catch (err) {
      message.error('Problem fetching projects')
    }
  }, [props.loginConfigId,props.toolName]);

  const getExtraFieldsData = (config) => {
    const { portfolioName, companyDomain } = config;
    const data = projects[portfolioName].find(project => project.companyDomain === companyDomain);
    return{
      portfolioId: data.portfolioId,
      portfolioName,
      companyDomain,
      companyName: data.companyName
    }
  }

  const isProjectFieldDisabled = useCallback((fieldKey, form) => {
    const fieldConfiguration = form.getFieldValue("configurations")[fieldKey];
    return (!fieldConfiguration || !fieldConfiguration.portfolioName);
  }, []);

  const onPortfolioChange = useCallback((value, field) => {
    const { name } = field;
    const configurations = form.getFieldValue("configurations");
    configurations[name] = {
      ...configurations[name],
      companyDomain: undefined,
    }
    form.setFieldsValue({ configurations });
  }, [form]);



  const extraFields = useMemo(() => ([{
      name: 'portfolioName',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Portfolio',
      options: Object.keys(projects).map(option => ({ label:option, value:option })),
      props: {
        onChange: onPortfolioChange,
        autoFocus: true
      },
      required: true,
      loading:isEmpty(projects)
    },
    {
      name: 'companyDomain',
      colSpan: '12',
      type: FieldTypes.SELECT,
      label: 'Company Name',
      props: {
        getFormListOptions: (fieldKey) => {
          const fieldConfiguration = form.getFieldValue("configurations")[fieldKey];
          const portfolioName = fieldConfiguration?.portfolioName;
          if(!isEmpty(portfolioName)){
            return projects[portfolioName]?.map(project =>({ label:project.companyName, value:project.companyDomain}))
          }
        },
      },
      required: true,
      propsGenerator: (fieldKey) => ({ disabled: isProjectFieldDisabled(fieldKey, form)}),
      loading:isEmpty(projects)
    },
  ]), [form,projects,isProjectFieldDisabled,onPortfolioChange]);

  return (
    <GenericMappingForm
      ref={ref}
      form={form}
      projects={projects}
      getExtraFieldsData={getExtraFieldsData}
      extraFields={extraFields}
      formDefaultValues={initialValues}
      {...props}
    />
  )
})

export default SecurityScorecardMappingForm;

const parseGroupSelectOption = (options) => {

  let groupKeyOptions = {};

  map(options, option => {
    const { name, id, otherProperties:{portfolioName,portfolioId} } = option || {};
    if(groupKeyOptions[portfolioName]) {
      groupKeyOptions[portfolioName].push({ companyName:name, companyDomain:id, portfolioId, portfolioName})
    } else {
      groupKeyOptions[portfolioName] = [{ companyName:name, companyDomain:id , portfolioId ,portfolioName}]
    }
  })
  return groupKeyOptions
}